import { createStore } from 'vuex'
import axios from 'axios'
import {csv} from 'd3-fetch';

const d3 = {
  csv
}

export default createStore({
  state: {
    articles: [],
    filteredArticles: [],
    videos: [],
    themas: [],
    hero: [],
    selected: undefined,
    chart_data: null
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.articles = data.articles;
      state.videos = data.videos;
      state.themas = data.themas;
      state.hero = data.hero;
    },

    SAVE_CHARTDATA (state, data) {
      state.chart_data = data;
    },

    UPDATE_SELECTION(state, obj) {
      state.selected = obj;
    }
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        if(state.articles.length > 0) {
          resolve();
          return;
        }

        axios
          .get(process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    loadChartData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        if(state.articles.length > 0) {
          resolve();
          return;
        }

        d3
          .csv(process.env.BASE_URL + "data/overgewicht.csv")
          .then(result => {
            commit("SAVE_CHARTDATA", result);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    updateSelection({commit}, state ) {
      commit("UPDATE_SELECTION", {name: state.name, index: state.index});
    }
  },
  modules: {

  }
})
